import type { SxStyle } from '@aibees/shared/theme';
import { CSSProperties } from 'react';

export const root: SxStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  gap: 1,
};

export const name: SxStyle = {
  textDecoration: 'none',
};

export const img: CSSProperties = { width: '100%', height: 'auto' };

export const b1: SxStyle = { display: 'flex', flex: 1, minWidth: 0 };

export const b2: SxStyle = {
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  overflow: 'hidden',
  width: '100%',
  gap: '2px',
  display: 'flex',
};

export const b3: SxStyle = {
  flexDirection: 'row',
  justifyContent: 'space-between',
  display: 'flex',
  width: '100%',
};

export const b4: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 0.5,
  overflow: 'hidden',
  alignItems: 'center',
  flex: 1,
  minWidth: 0,
};

export const lastUpdate: SxStyle = {
  // Hidden by default, shown on row hover (see search-table styles)
  display: 'none',
};
